import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const demoShopId = (import.meta.env.VITE_DEMO_SHOP_ID as string | undefined) || 'shop-123'
const demoShopName = (import.meta.env.VITE_DEMO_SHOP_NAME as string | undefined) || 'Shopbay'

interface ShopState {
  shopId: string
  shopName: string
  brandColor?: string
  setShop: (id: string, name: string, brandColor?: string) => void
}

export const useShopStore = create<ShopState>()(
  persist(
    (set) => ({
      shopId: demoShopId, // TODO: replace with auth-based shop selection
      shopName: demoShopName,
      brandColor: undefined,
      setShop: (id, name, brandColor) => set({ shopId: id, shopName: name, brandColor }),
    }),
    {
      name: 'shopbay-shop',
      partialize: (state) => ({ shopId: state.shopId, shopName: state.shopName }),
    }
  )
)
